import { Action, InputType } from '@projectstorm/react-canvas-core';
import ZoomFunction from '../../CanvasController/ZoomFunction';
/**
 * Inverts Scroll
 */
export default class CustomMouseWheelAction extends Action {
  constructor() {
    super({
      type: InputType.MOUSE_WHEEL,
      fire: (event: any) => {
        ZoomFunction(this.engine, event);
      },
    });
  }
}
